import React from 'react';
import { Card } from '@/components/ui/card';
import { Home } from 'lucide-react';

/* eslint-disable react/prop-types */
export function TopSharedWidget({ topShared, topSharedRows }) {
  if (!topShared || !topShared.top || topShared.top.length === 0) return null;

  return (
    <Card data-testid="top-shared-widget" className="p-6 mb-8 border border-border shadow-sm">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div>
          <h2 className="text-lg font-semibold text-primary">Top-Shared Listings</h2>
          <p className="text-xs text-muted-foreground">Most shared on social in the last {topShared.days} days · {topShared.total_events} events</p>
        </div>
      </div>
      <ul className="divide-y divide-border/60" data-testid="top-shared-list">
        {topSharedRows.map((row) => (
          <li key={row.property_id} data-testid={`top-shared-row-${row.property_id}`} className="py-3 flex items-center gap-4">
            <div className="w-14 h-14 flex-shrink-0 rounded-lg overflow-hidden bg-muted">
              {row.image ? (
                <img src={row.image} alt={row.title} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center"><Home className="w-6 h-6 text-muted-foreground" /></div>
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{row.title}</div>
              <div className="text-xs text-muted-foreground truncate">{row.city}</div>
              <div className="flex flex-wrap gap-1 mt-1">
                {row.sortedSources.map(([src, cnt]) => (
                  <span key={src} className="text-[10px] px-2 py-0.5 rounded-full bg-primary/10 text-primary uppercase tracking-wide" data-testid={`top-shared-source-${row.property_id}-${src}`}>
                    {src} · {cnt}
                  </span>
                ))}
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="text-lg font-bold text-primary tabular-nums">{row.total}</div>
              <div className="text-[10px] text-muted-foreground uppercase tracking-wide">
                {row.preview_count} preview · {row.click_count} click
              </div>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
}
/* eslint-enable react/prop-types */
